import React from "react";
import { DraggableSidebarItem } from "../DraggableSidebarItem";
import { useEditorStore, EditorField } from "../../../store";

export const FieldsPanel: React.FC = () => {
  const fields = useEditorStore((state) => state.config.fields);
  const existingKeys = fields.map((f) => f.key);
  const existingTypes = fields.map((f) => f.type);

  // Funciones de validación
  const isUsed = (key: string) => existingKeys.includes(key);
  const isTypeUsed = (type: EditorField["type"]) =>
    existingTypes.includes(type);

  // 1. Agrupamos y filtramos los campos únicos para que desaparezcan si ya se están usando
  const contactFields = [
    { type: "text" as const, label: "Primer Nombre", systemKey: "first_name" },
    { type: "text" as const, label: "Apellido", systemKey: "last_name" },
    { type: "email" as const, label: "Correo Electrónico", systemKey: "email" },
    { type: "tel" as const, label: "Número de Teléfono", systemKey: "phone" },
  ].filter((f) => !isUsed(f.systemKey));

  const shippingFields = [
    { type: "text" as const, label: "Dirección 1", systemKey: "address_1" },
    { type: "text" as const, label: "Dirección 2", systemKey: "address_2" },
    { type: "select" as const, label: "Ciudad", systemKey: "city" },
    {
      type: "select" as const,
      label: "Provincia / Estado",
      systemKey: "zone_code",
    },
    { type: "text" as const, label: "Código Postal", systemKey: "zip" },
    {
      type: "text" as const,
      label: "Código de País",
      systemKey: "country_code",
    },
  ].filter((f) => !isUsed(f.systemKey));

  const componentFields = [
    {
      type: "order_summary" as const,
      label: "Resumen del Pedido",
      systemKey: "order_summary",
    },
    {
      type: "shipping_method" as const,
      label: "Método de Envío",
      systemKey: "shipping_method",
    },
  ].filter((f) => !isTypeUsed(f.type));

  // 2. Los campos básicos siempre están disponibles
  const basicFields = [
    { type: "text" as const, label: "Campo de Texto" },
    { type: "number" as const, label: "Campo Numérico" },
    { type: "select" as const, label: "Dropdown" },
    { type: "date" as const, label: "Selector de Fecha" },
    { type: "checkbox" as const, label: "Casilla de Verificación" },
  ];

  return (
    <div className="p-5 space-y-6">
      <div className="text-sm text-gray-500 mb-2">
        Arrastra y suelta campos hacia el lienzo para añadirlos a tu formulario.
      </div>

      <s-stack gap="large-400" direction="block">
        {/* Renderizado condicional: Si no hay campos de contacto disponibles, ocultamos la cabecera entera */}
        {contactFields.length > 0 && (
          <s-stack gap="small" direction="block">
            <s-text type="strong">Contact Info</s-text>
            {contactFields.map((f) => (
              <DraggableSidebarItem
                key={f.systemKey}
                type={f.type}
                label={f.label}
                systemKey={f.systemKey}
              />
            ))}
          </s-stack>
        )}

        {/* Sección de Dirección de Envío */}
        {shippingFields.length > 0 && (
          <s-stack gap="small" direction="block">
            <s-text type="strong">Dirección de Envío</s-text>
            {shippingFields.map((f) => (
              <DraggableSidebarItem
                key={f.systemKey}
                type={f.type}
                label={f.label}
                systemKey={f.systemKey}
              />
            ))}
          </s-stack>
        )}

        {/* Sección de Campos Básicos */}
        <s-stack gap="small" direction="block">
          <s-text type="strong">Campos Básicos</s-text>
          {basicFields.map((f, index) => (
            <DraggableSidebarItem
              key={`${f.type}-${index}`}
              type={f.type}
              label={f.label}
            />
          ))}
        </s-stack>

        {/* Sección de Componentes */}
        {componentFields.length > 0 && (
          <s-stack gap="small" direction="block">
            <s-text type="strong">Components</s-text>
            {componentFields.map((f) => (
              <DraggableSidebarItem
                key={f.systemKey}
                type={f.type}
                label={f.label}
                systemKey={f.systemKey}
              />
            ))}
          </s-stack>
        )}
      </s-stack>
    </div>
  );
};
